<app-module-header
  [title]="organization.organizationName + ' - ' + 'Parkifly ' + ('KEY_TASKS.USER' | transloco)"
  icon="diversity_1"
></app-module-header>
